module.exports = __webpack_public_path__ + "img/lose.07fc90c2.png";